import { Skeleton, SkeletonTypeMap } from '@mui/material'

type LoadingSkeletonProps = {
    count?: number
} & SkeletonTypeMap['props']

/**
 * Utility component to render multiple skeletons at once (or one).
 * See: {@link https://mui.com/components/skeleton/}
 *
 * @param count Number of skeletons to render. If not provided, only one skeleton will be rendered. Must be > 0.
 */
export default function LoadingSkeleton({ count, ...skeletonProps }: LoadingSkeletonProps) {
    if (count !== undefined && count < 0) {
        throw new Error('LoadingSkeleton: Count must be >= 0')
    }

    if (count === 0) {
        return null
    }

    return (
        <>
            {count ? (
                [...Array(count)].map((_, index) => <Skeleton key={index} {...skeletonProps} role="progressbar" />)
            ) : (
                <Skeleton {...skeletonProps} role="progressbar" />
            )}
        </>
    )
}
